import * as R from 'ramda'

export * from './profile'

export function setRater(rater) {
  return {
    type: 'SET_RATER',
    rater,
  }
}

export const SET_CUSTOMER_RATER = 'SET_CUSTOMER_RATER'
export const setCustomerRater = (email, data) => ({
  type: SET_CUSTOMER_RATER,
  email,
  data,
})

export const SET_CUSTOMER_NPS = 'SET_CUSTOMER_NPS'
export const setCustomerNPS = (email, data) => ({
  type: SET_CUSTOMER_NPS,
  email,
  data,
})

export const SET_NPS = 'SET_NPS'
export function setNps(nps) {
  return {
    type: SET_NPS,
    nps,
  }
}

export const SET_RELIABILITY = 'SET_RELIABILITY'
export function setReliability(reliability) {
  return {
    type: SET_RELIABILITY,
    reliability,
  }
}

export const SET_PAGINATED_FEEDBACK = 'SET_PAGINATED_FEEDBACK'
export function setPaginatedFeedback(numberOfFeedback, feedback) {
  return {
    type: SET_PAGINATED_FEEDBACK,
    numberOfFeedback,
    feedback,
  }
}

export const SET_TICKET_SATISFACTION_GRAPH = 'SET_TICKET_SATISFACTION_GRAPH'
export const setTicketSatisfactionGraph = (answers) => ({
  type: SET_TICKET_SATISFACTION_GRAPH,
  answers,
})

export const SET_TICKET_SATISFACTION_LEADERBOARD = 'SET_TICKET_SATISFACTION_LEADERBOARD'
export const setTicketSatisfactionLeaderboard = (count, leaderboard) => ({
  type: SET_TICKET_SATISFACTION_LEADERBOARD,
  count,
  leaderboard,
})

export const TRIGGER_LEADERBOARD_SORT_FILTER = 'TRIGGER_LEADERBOARD_SORT_FILTER'
export const triggerLeaderboardSortFilter = (filterKey, descending) => ({
  type: TRIGGER_LEADERBOARD_SORT_FILTER,
  filterKey,
  descending,
})

export const SET_ANSWERS_FEEDBACK_PAGE = 'SET_ANSWERS_FEEDBACK_PAGE'
export const setAnswersFeedbackPage = (answers, numberOfAnswers) => ({
  type: SET_ANSWERS_FEEDBACK_PAGE,
  answers,
  numberOfAnswers,
})

export const SET_ANSWERS = 'SET_ANSWERS'
export function setAnswers(numberOfAnswers, answers) {
  return {
    type: SET_ANSWERS,
    numberOfAnswers,
    answers,
  }
}

export const UPDATE_FEEDBACK_TESTIMONIAL = 'UPDATE_FEEDBACK_TESTIMONIAL'
export function updateFeedbackTestimonial(answerDetailId, publishedAsTestimonial) {
  return {
    type: UPDATE_FEEDBACK_TESTIMONIAL,
    answerDetailId,
    publishedAsTestimonial,
  }
}

export const SET_CUSTOMER = 'SET_CUSTOMER'
export function setCustomer(customer) {
  return {
    type: SET_CUSTOMER,
    customer,
  }
}

export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export function setCustomers(customers) {
  return {
    type: SET_CUSTOMERS,
    customers,
  }
}

export const UPDATE_SELECTED_CUSTOMER = 'UPDATE_SELECTED_CUSTOMER'
export function updateSelectedCustomer(page, email) {
  return {
    type: UPDATE_SELECTED_CUSTOMER,
    page,
    customerEmail: email,
  }
}

export const SET_CUSTOMER_FEEDBACK = 'SET_CUSTOMER_FEEDBACK'
export function setCustomerFeedback(email, feedback) {
  return {
    type: SET_CUSTOMER_FEEDBACK,
    customerEmail: email,
    feedback,
  }
}

export const SET_SURVEY_DATA = 'SET_SURVEY_DATA'
export const setSurvey = (surveyData) => ({
  type: SET_SURVEY_DATA,
  surveyData,
})

export const SET_SURVEY_LIST = 'SET_SURVEY_LIST'
export const setSurveyList = (surveyList) => {
  return {
    type: SET_SURVEY_LIST,
    surveyList,
  }
}

export const HAS_NO_SURVEY_ACCESS = 'HAS_NO_SURVEY_ACCESS'
export const hasNoSurveyAccess = () => {
  return {
    type: HAS_NO_SURVEY_ACCESS,
  }
}

export const TRIGGER_FILTER_CHECKBOX = 'TRIGGER_FILTER_CHECKBOX'
export const triggerFilterCheckbox = (filter) => ({
  type: TRIGGER_FILTER_CHECKBOX,
  filter,
})

export const SET_CUSTOMERS_SEARCH_PARAM = 'SET_CUSTOMER_SEARCH_PARAM'
export const setCustomerSearchParam = (searchParam) => ({
  type: SET_CUSTOMERS_SEARCH_PARAM,
  searchParam,
})

export const SET_PAGINATED_CUSTOMERS = 'SET_PAGINATED_CUSTOMERS'
export function setPaginatedCustomers(numberOfCustomers, customers) {
  return {
    type: SET_PAGINATED_CUSTOMERS,
    numberOfCustomers,
    customers,
  }
}

export const LOGGING_IN = 'LOGGING_IN'
export const loggingIn = () => ({
  type: LOGGING_IN,
})

export const LOGIN_FAILED = 'LOGIN_FAILED'
export const loginFailed = (error) => ({
  type: LOGIN_FAILED,
  error,
})

export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL'
export const loginSuccessful = () => ({
  type: LOGIN_SUCCESSFUL,
})

export const SIGNING_UP = 'SIGNING_UP'
export const signingUp = () => ({
  type: SIGNING_UP,
})

export const SIGNUP_FAILED = 'SIGNUP_FAILED'
export const signupFailed = (error) => ({
  type: SIGNUP_FAILED,
  error,
})

export const SIGNUP_SUCCESSFUL = 'SIGNUP_SUCCESSFUL'
export const signupSuccessful = () => ({
  type: SIGNUP_SUCCESSFUL,
})

export const RESET_PASSWORD = 'RESET_PASSWORD'
export const resetPassword = (email) => ({
  type: RESET_PASSWORD,
  email,
})

export const SET_USER_INFO = 'SET_USER_INFO'
export const setUserInfo = (userInfo) => ({
  type: SET_USER_INFO,
  userInfo,
})

export const HAS_NO_SURVEY = 'HAS_NO_SURVEY'
export const hasNoSurvey = () => ({
  type: HAS_NO_SURVEY,
})

export const SET_HOME_PAGE_ID = 'HOME_PAGE_ID'
export const setHomePageId = (homePageId) => ({
  type: SET_HOME_PAGE_ID,
  homePageId,
})

export const SET_HOME_PAGE_URL = 'HOME_PAGE_URL'
export const setHomePageUrl = (homePageUrl) => ({
  type: SET_HOME_PAGE_URL,
  homePageUrl,
})

export const SATISFACTION_RATINGS_LOADED = 'SATISFACTION_RATINGS_LOADED'
export const satisfactionRatingsLoaded = () => ({
  type: SATISFACTION_RATINGS_LOADED,
})

export const SATISFACTION_RATINGS_LOAD_FAILED = 'SATISFACTION_RATINGS_LOAD_FAILED'
export const satisfactionRatingsLoadFailed = () => ({
  type: SATISFACTION_RATINGS_LOAD_FAILED,
})

export const SET_ZENDESK_AUTHENTICATION_SETTING = 'SET_ZENDESK_AUTHENTICATION_SETTING'
export const setZendeskAuthenticationSetting = (settings) => ({
  type: SET_ZENDESK_AUTHENTICATION_SETTING,
  settings,
})

export const REMOVE_CONNECTWISE_CREDENTIAL = 'REMOVE_CONNECTWISE_CREDENTIAL'
export const removeConnectwiseCredential = () => ({
  type: REMOVE_CONNECTWISE_CREDENTIAL,
})

export const SET_CONNECTWISE_AUTHENTICATION_SETTING = 'SET_CONNECTWISE_AUTHENTICATION_SETTING'
export const setConnectwiseAuthenticationSetting = (settings) => ({
  type: SET_CONNECTWISE_AUTHENTICATION_SETTING,
  settings,
})

export const SET_AUTOTASK_AUTHENTICATION_SETTING = 'SET_AUTOTASK_AUTHENTICATION_SETTING'
export const setAutotaskAuthenticationSetting = (settings, surveyToken) => ({
  type: SET_AUTOTASK_AUTHENTICATION_SETTING,
  settings,
  surveyToken,
})

export const REMOVE_AUTOTASK_CREDENTIAL = 'REMOVE_AUTOTASK_CREDENTIAL'
export const removeAutotaskCredential = (surveyToken) => ({
  type: REMOVE_AUTOTASK_CREDENTIAL,
  surveyToken,
})

export const SET_SURVEY_FROM_ID = 'SET_SURVEY_FROM_ID'
export const setSurveyFromId = (survey) => ({
  type: SET_SURVEY_FROM_ID,
  survey,
})

export const SET_COMPANY_ACCOUNT_SETTING = 'SET_COMPANY_ACCOUNT_SETTING'
export const setCompanyAccountSetting = (accountSetting) => ({
  type: SET_COMPANY_ACCOUNT_SETTING,
  accountSetting,
})

export const ZENDESK_AUTHENTICATION_FAILED = 'ZENDESK_AUTHENTICATION_FAILED'
export const zendeskAuthenticationFailed = () => ({
  type: ZENDESK_AUTHENTICATION_FAILED,
})

export const ZENDESK_AUTHENTICATION_SUCCESS = 'ZENDESK_AUTHENTICATION_SUCCESS'
export const zendeskAuthenticationSuccess = () => ({
  type: ZENDESK_AUTHENTICATION_SUCCESS,
})

export const ZENDESK_SATISFACTION_SYNC_FAILED = 'ZENDESK_SATISFACTION_SYNC_FAILED'
export const zendeskSatisfactionSyncFailed = () => ({
  type: ZENDESK_SATISFACTION_SYNC_FAILED,
})

export const ZENDESK_SATISFACTION_SYNC_SUCCESS = 'ZENDESK_SATISFACTION_SYNC_SUCCESS'
export const zendeskSatisfactionSyncSuccess = () => ({
  type: ZENDESK_SATISFACTION_SYNC_SUCCESS,
})

export const REMOVE_ZENDESK_SYNC_SUCCESS = 'REMOVE_ZENDESK_SYNC_SUCCESS'
export const removeZendeskSyncSuccess = () => ({
  type: REMOVE_ZENDESK_SYNC_SUCCESS,
})

export const REMOVE_ZENDESK_SYNC_FAILED = 'REMOVE_ZENDESK_SYNC_FAILED'
export const removeZendeskSyncFailed = () => ({
  type: REMOVE_ZENDESK_SYNC_FAILED,
})

export const ZENDESK_END_USER_AUTHENTICATION_FAILED = 'ZENDESK_END_USER_AUTHENTICATION_FAILED'
export const zendeskEndUserAuthenticationFailed = () => ({
  type: ZENDESK_END_USER_AUTHENTICATION_FAILED,
})

export const ZENDESK_END_USER_AUTHENTICATION_SUCCESS = 'ZENDESK_END_USER_AUTHENTICATION_SUCCESS'
export const zendeskEndUserAuthenticationSuccess = () => ({
  type: ZENDESK_END_USER_AUTHENTICATION_SUCCESS,
})

export const SET_ZENDESK_END_USER_CREDENTIAL = 'SET_ZENDESK_END_USER_CREDENTIAL'
export const setZendeskEndUserCredential = (credential) => ({
  type: 'SET_ZENDESK_END_USER_CREDENTIAL',
  credential,
})

export const SET_FEEDBACK_FILTER = 'SET_FEEDBACK_FILTER'
export const setFeedbackFilter = (query) => ({
  type: 'SET_FEEDBACK_FILTER',
  query,
})

export const LOGOUT = 'LOGOUT'
export const logout = () => ({
  type: LOGOUT,
})

export const SET_ENTITIES = 'SET_ENTITIES'
export const setEntities = (entities, allIds = []) => ({
  type: SET_ENTITIES,
  entities,
  allIds: R.map((value) => transformToArray(value), allIds),
})

export const SET_USER = 'SET_USER'
export const setUser = (user) => ({
  type: SET_USER,
  user,
})

const transformToArray = (data) => [].concat(data)

export const SET_MENU_CONFIG = 'SET_MENU_CONFIG'
export const setMenuConfig = (data) => ({
  type: SET_MENU_CONFIG,
  config: data,
})

export const SET_FEATURE_TOGGLES = 'SET_FEATURE_TOGGLES'
export const setFeatureToggles = (data) => ({
  type: SET_FEATURE_TOGGLES,
  config: data,
})

export const getFeatureToggles = (name) => (state) => R.path(['featureToggles', name], state)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/actions/sync/index.js